//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import deptSel from '../dw-dept/component/dept-selector'
export default {
    components: {deptSel},
    props: {
        search: {
            type: Object,
            default: () => ({
                rowguid: '',
				code: '',
				nodeguid: '',
				iskeyword: ''
            })
        }
    },
    data () {
        return {
            form: {
				pretext: '',
                nodetext: '',
                alerttype: '任意一个',

				iszhuanban: '0',
                keyvalue: 0,
                usetext: '',
                useafter: '',
                userlist: [{
                    "settingguid": this.search['rowguid'],
                    "audittype":"指定角色",
                    "auditid":"",
                    "auditname":null
                }],
				auditcata: '正常审核'
			},
            hsController: false
        }
    },
    computed: {
        highSetIcon: function(){
            return !this.hsController ? 'el-icon-plus' : 'el-icon-minus';
        },
        detailExtra: function(){
            return {
                rowguid: this.search['rowguid']
            }
        },
		iskeyword: function() {
			return this.search['iskeyword'];
		}
	},
	watch: {

	},
	methods: {
        afterDetail: function (data){
            if(data.userlist.length == 0){
                data.userlist.push({
                    "settingguid": this.search['rowguid'],
                    "audittype":"指定角色",
                    "auditid":"",
                    "auditname":null
                })
            }
        },
        clearFollowAuditor: function(node){
            node.auditid = '';
            node.auditname = '';
        },
        auditSelect: function (e, node, obj){
            node.auditid = e[obj.id];
            node.auditname = e[obj.name];
        },
        addAuditor: function(){
            this.form.userlist.push({
                "settingguid": this.search['rowguid'],
                "audittype":"指定角色",
                "auditid":"",
                "auditname":null
            })
        },
        submitHandler: function (){
            this.form.rowguid = this.search['rowguid'];
            this.form.nodeguid = this.search['nodeguid'];
            this.form.code = this.search['code'];

            this.$post(this.getStore('sysUrl')+'/node/settingadd', this.form, function(data, res){
                ShowMsg.call(this, res.msg);
                this.cancleHandler();
            },true)
        },
        cancleHandler() {
            this.$emit('close');
        },
	},
	mounted: function() {

	}
}
